<style>
    .bg {

        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        background: var(--titleColor);
        border-radius: 8px;
    }
</style>
<div class="container mt-4">
    <h2>Dashboard</h2>
    <!-- <div class="row mt-3">
       
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/filterHeaderlist" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Headers Name</h5>
                        <p class="card-text">Headers/Filters Details.</p>
                    </div>
                </a>
            </div>
        </div>

       
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/filterHeaderlistValue" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Headers Value</h5>
                        <p class="card-text">Headers/Filters Details.</p>
                    </div>
                </a>
            </div>
        </div>

       
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/filterHeaderlistSearch" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Headers Search</h5>
                        <p class="card-text">Headers/Filters Details.</p>
                    </div>
                </a>
            </div>
        </div>

    </div> -->
    <div class="row mt-3">

        <!-- Card 1 -->
        <!-- <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/profiles" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">User</h5>
                        <p class="card-text">User Details.</p>
                    </div>
                </a>
            </div>
        </div> -->
        <!-- Card 4 -->
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/profiles" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Profiles</h5>
                        <p class="card-text">Profiles Details.</p>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/bannerlist" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Type Banner</h5>
                        <p class="card-text">Banner Details.</p>
                    </div>
                </a>
            </div>
        </div>
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/typelist" class="card-link">

                    <div class="card-body">
                        <h5 class="card-title">Type</h5>
                        <p class="card-text">Type Details.</p>
                    </div>
                </a>
            </div>
        </div>

       
        
        <div class="row mt-3">
            <!-- Category Card 1 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/mastercategory" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title"> Category</h5>
                            <p class="card-text"> Category Details.</p>
                        </div>
                    </a>
                </div>
            </div>
            <!-- Sub Category Card 1 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/mastersubcategory" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Sub Category</h5>
                            <p class="card-text">Sub Category Details.</p>
                        </div>
                    </a>
                </div>
            </div>

            <!--Document Card 7 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a routerLink="/gallerylist" class="card-link">
                        <div class="card-body">
                            <h5 class="card-title">Gallery</h5>
                            <p class="card-text">Gallery Details.</p>
                        </div>
                    </a>
                </div>
            </div>




        </div>
        <div class="row mt-3">
            <!-- Card 1 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/questionnairelist" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Questionnaire</h5>
                            <p class="card-text"> Questionnaire Details.</p>
                        </div>
                    </a>
                </div>
            </div>
            <!-- Card 1 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/questionslist" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Question</h5>
                            <p class="card-text">Question Details.</p>
                        </div>
                    </a>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a routerLink="/res" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Response</h5>
                            <p class="card-text">Response Details.</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <!-- Card 1 -->
            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/masterMenu" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Menu</h5>
                            <p class="card-text"> Menu Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->
            <!-- Card 2 -->
            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/SubMasterMenu" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Sub Menu</h5>
                            <p class="card-text">Sub Menu Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->

            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/MenuContent" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Menu Content</h5>
                            <p class="card-text">Menu Content Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->

        </div>

        <div class="row mt-3">
            <!-- Card 1 -->
            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/MenuPageContent" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">Menu Page Content</h5>
                            <p class="card-text"> Menu Page Content Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->
            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a href="/faqList" class="card-link">

                        <div class="card-body">
                            <h5 class="card-title">FAQ</h5>
                            <p class="card-text"> FAQ Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->
            <!-- <div class="col-md-3 mb-3">
                <div class="card bg">
                    <a routerLink="/logo" class="card-link">
                        <div class="card-body">
                            <h5 class="card-title">Logo</h5>
                            <p class="card-text">Logo Details.</p>
                        </div>
                    </a>
                </div>
            </div> -->

        </div>
        <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/callbackresponse" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Call Back Responses</h5>
                        <p class="card-text">Response Details.</p>
                    </div>
                </a>
            </div>
        </div>
        <!-- <div class="col-md-3 mb-3">
            <div class="card bg">
                <a routerLink="/userslist" class="card-link">
                    <div class="card-body">
                        <h5 class="card-title">Users List</h5>
                        <p class="card-text">User Details.</p>
                    </div>
                </a>
            </div>
        </div> -->
    </div>
</div>
<div class="container mt-4">
    <br>
</div>
